import Axios from 'axios';
import jwt_decode from 'jwt-decode';
import { LoginRequest } from '@/models/loginRequest';
import { UserTypes, getUserTypeFromString } from '@/enums/userTypes';

interface State {
  loggedIn: boolean;
  pending: boolean;
  token: string | null;
  refreshToken: string | null;
}
const mapState: State = {
  loggedIn: !!localStorage.getItem('admin/token'),
  pending: false,
  token: localStorage.getItem('admin/token'),
  refreshToken: localStorage.getItem('admin/refreshToken'),
};

const mapGetters = {
  accountId: (state: State) => {
    if (!state.token) {
      return null;
    } else {
      const decodedToken = jwt_decode(state.token);
      const findKey = Object.keys(decodedToken).find((key) => {
        return /sid$/i.test(key);
      });
      if (!findKey) {
        return null;
      } else {
        return decodedToken[findKey];
      }
    }
  },
  userType: (state: State) => {
    if (!state.token) {
      return UserTypes.All;
    } else {
      const decodedToken = jwt_decode(state.token);
      const findKey = Object.keys(decodedToken).find((key) => {
        return /role$/i.test(key);
      });
      if (!findKey) {
        return UserTypes.All;
      } else {
        return getUserTypeFromString(decodedToken[findKey]);
      }
    }
  },
};

const mapActions = {
  login({ commit }: any, data: any) {
    const userId = data.userId;
    const password = data.password;

    commit('login');
    localStorage.removeItem('admin/token');
    localStorage.removeItem('admin/refreshToken');

    const request: LoginRequest = {
      grant_type: 'password',
      schoolId: undefined,
      userId,
      password,
      refreshToken: undefined,
    };
    return Axios.post('/token', request).then((response) => {
      switch (response.data.userType as UserTypes) {
        case UserTypes.Admin:
        case UserTypes.Owner:
          break;
        default:
          commit('login_error');
          throw new Error('ユーザIDまたはパスワードが正しくありません。');
      }

      localStorage.setItem('admin/token', response.data.token);
      localStorage.setItem('admin/refreshToken', response.data.refreshToken);

      commit('login_success');
    }).catch((error) => {
      commit('login_error');
      throw new Error('ユーザIDまたはパスワードが正しくありません。');
    });
  },
  refreshToken({ commit }: any) {
    const refreshToken = localStorage.getItem('admin/refreshToken');
    if (!refreshToken) {
      throw new Error('リフレッシュトークンが見つかりません。');
    }

    commit('login');

    const request: LoginRequest = {
      grant_type: 'refresh_token',
      refreshToken,
      schoolId: undefined,
      userId: undefined,
      password: undefined,
    };
    return Axios.post('/token', request).then((response) => {
      switch (response.data.userType as UserTypes) {
        case UserTypes.Admin:
        case UserTypes.Owner:
          break;
        default:
          throw new Error();
      }

      localStorage.setItem('admin/token', response.data.token);
      localStorage.setItem('admin/refreshToken', response.data.refreshToken);

      commit('login_success');
    }).catch((error) => {
      commit('login_error');
      throw new Error('トークンの取得に失敗しました。');
    });
  },
  logout({ commit }: any) {
    localStorage.removeItem('admin/token');
    localStorage.removeItem('admin/refreshToken');
    commit('logout');
  }
};

const mapMutations = {
  login(state: State) {
    state.pending = true;
  },
  login_success(state: State) {
    state.loggedIn = true;
    state.pending = false;
    state.token = localStorage.getItem('admin/token');
    state.refreshToken = localStorage.getItem('admin/refreshToken');
  },
  login_error(state: State) {
    state.loggedIn = false;
    state.pending = false;
    state.token = null;
    state.refreshToken = null;
  },
  logout(state: State) {
    state.loggedIn = false;
    state.token = null;
    state.refreshToken = null;
  }
};

export default {
  namespaced: true,
  state: mapState,
  getters: mapGetters,
  actions: mapActions,
  mutations: mapMutations,
};
